const SUPPORTS_LIST_FORMAT =
    'ListFormat' in Intl && Intl.ListFormat.supportedLocalesOf(['en-US']).includes('en-US');

/**
 * Define the formatter once so it's faster since we're always using the same locale and options.
 */
const LIST_FORMATTER = SUPPORTS_LIST_FORMAT
    ? new Intl.ListFormat('en-US', { style: 'long', type: 'conjunction' })
    : undefined;

/**
 * Format a list of strings into a human-readable string using Intl.ListFormat
 * if supported, or a fallback implementation if not.
 */
export function intlFormatList(values: string[]): string {
    if (LIST_FORMATTER) {
        return LIST_FORMATTER.format(values);
    }

    // Fallback for non-supported browsers
    if (values.length === 0) {
        return '';
    }

    if (values.length === 1) {
        return values[0];
    }

    const lastValue = values.pop();
    return `${values.join(', ')} and ${lastValue}`;
}
